module.exports = __webpack_public_path__ + "images/06_79465466.png";